var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#3749E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 26.8643H30.013M33.3333 13.332H16.2667C14.7732 13.332 14.0265 13.332 13.456 13.6227C12.9543 13.8783 12.5463 14.2863 12.2906 14.7881C12 15.3585 12 16.1052 12 17.5987V30.3987C12 31.8922 12 32.6389 12.2906 33.2093C12.5463 33.7111 12.9543 34.1191 13.456 34.3747C14.0265 34.6654 14.7732 34.6654 16.2667 34.6654H31.7333C33.2268 34.6654 33.9735 34.6654 34.544 34.3747C35.0457 34.1191 35.4537 33.7111 35.7094 33.2093C36 32.6389 36 31.8922 36 30.3987V22.932C36 21.4386 36 20.6918 35.7094 20.1214C35.4537 19.6196 35.0457 19.2117 34.544 18.956C33.9735 18.6654 33.2268 18.6654 31.7333 18.6654H17.3333M30.601 26.8643C30.601 27.1957 30.3324 27.4643 30.001 27.4643C29.6697 27.4643 29.401 27.1957 29.401 26.8643C29.401 26.533 29.6697 26.2643 30.001 26.2643C30.3324 26.2643 30.601 26.533 30.601 26.8643Z",
    stroke: "#B3B8D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWallet;